export const GET_SUB_CATEGORY_LIST_INITIAL_DATA = {
  subCategories: [],
};

export const SUB_CATEGORY_ACTION_CONFIRM_MESSAGE = {
  CREATE: {
    title: '카테고리 생성',
    message: '2차 카테고리를 저장하시겠습니까?',
  },
  EDIT: {
    title: '카테고리 수정',
    message: '2차 카테고리 수정 사항을 저장하시겠습니까?',
  },
  DELETE: {
    title: '카테고리 삭제',
    message: '2차 카테고리를 삭제하시겠습니까?',
  },
  ADD_CANCEL: {
    title: '카테고리 삭제',
    message: '2차 카테고리 추가를 취소하시겠습니까?',
  },
  EDIT_CANCEL: {
    title: '카테고리 취소',
    message: '2차 카테고리 편집을 취소하시겠습니까?',
  },
};

export const SUB_CATEGORY_ACTION_TYPE = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  ADD_CANCEL: 'ADD_CANCEL',
  EDIT_CANCEL: 'EDIT_CANCEL',
};

export const SUB_CATEGORY_LIST_FILTER_OPTION_MODEL = {
  id: null,
  name: null,
  status: null,
  isExhibit: null,
};

export const SUB_CATEGORY_LIST_SORT_OPTION_MODEL = [];
